export const TabKeyEnum = {
  RESTORED_ALARM: '0',
  UNRESTORED_ALARM: '1',
};

export const TabKeyStateDisplay = {
  [TabKeyEnum.RESTORED_ALARM]: '已恢复报警',
  [TabKeyEnum.UNRESTORED_ALARM]: '未恢复报警',
};

export const GradeEnum = {
  ALL: 5,
  TOP: 0,
  HIGH: 1,
  MIDDLE: 2,
  LOW: 3,
  LOWEST: 4,
};

// 资产类型枚举
export enum deviceAssetTypeEnum {
  ENERGYSTORAGEARRAY = 1, // 储能阵列
  PVSTATION = 2, // 光伏站
  NETENERGY = 3, // 微网能源资产
  CHARGING = 4, // 充电站
  TOPOLOGY = 5, // 能源介质拓扑
  NEW_ENERGYSTORAGEARRAY = 6, // 新储能阵列
  GAS_PREPARATION_STATION = 7, // 气体制备站
  HVAC = 8, // 暖通空调
  WIND_POWER = 9, // 风电站
}
